<template>
  <div class="wrapper" :class="isPC ? 'pc' : 'h5'">
    <h1>Alchemy Toys Value Query</h1>
    <div class="form">
      <van-field name="check" label="等级">
        <template #input>
          <van-radio-group direction="horizontal" v-model="level">
            <van-radio :name="1">1</van-radio>
            <van-radio :name="2">2</van-radio>
            <van-radio name="3">3</van-radio>
            <van-radio name="4">4</van-radio>
            <van-radio name="5">5</van-radio>
            <van-radio name="6">6</van-radio>
            <van-radio name="7">7</van-radio>
            <van-radio name="8">8</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field v-model="turnFee" label="回合费(BNB)" />
      <van-field error :value="bnbValue.toFixed(6)" label="价值(BNB)" />
      <!-- <div class="btn-wrapper">
        <van-button type="primary" @click="calc">计算</van-button>
      </div> -->
    </div>
    <h1>奖池分配计算</h1>
    <div>
      <div class="input-group">
        <van-field
          type="digit"
          placeholder="请输入献祭分数"
          v-model.number="enlightenment.no1"
          label="启蒙者01"
        />
        <van-field
          type="digit"
          placeholder="请输入献祭分数"
          v-model.number="enlightenment.no2"
          label="启蒙者02"
        />
        <van-field
          type="digit"
          placeholder="请输入献祭分数"
          v-model.number="enlightenment.no3"
          label="启蒙者03"
        />
        <van-field
          type="digit"
          placeholder="请输入献祭分数"
          v-model.number="enlightenment.no4"
          label="启蒙者04"
        />
        <van-field
          type="digit"
          placeholder="请输入献祭分数"
          v-model.number="enlightenment.no5"
          label="启蒙者05"
        />
        <van-field
          type="digit"
          placeholder="请输入献祭分数"
          v-model.number="enlightenment.no6"
          label="启蒙者06"
        />
        <van-field
          type="digit"
          placeholder="请输入献祭分数"
          v-model.number="enlightenment.no7"
          label="启蒙者07"
        />

        <van-field
          type="number"
          placeholder="请输入奖池BNB数量"
          v-model.number="enlightenment.jackpot"
          label="启蒙奖池"
        />
        <!-- <van-field
          placeholder="请输入奖池BNB数量"
          :value="result"
          readonly
          disabled
          error
          label="开道者/启蒙者奖池"
        /> -->
      </div>
      <div class="result">
        <span
          >启蒙者1号获得：<span class="red">{{
            this.enlightReward.no1.toFixed(2)
          }}</span>
          BNB</span
        >
        <br /><span
          >启蒙者2号获得：<span class="red">{{
            this.enlightReward.no2.toFixed(2)
          }}</span>
          BNB</span
        >
        <br /><span
          >启蒙者3号获得：<span class="red">{{
            this.enlightReward.no3.toFixed(2)
          }}</span>
          BNB</span
        >
        <br /><span
          >启蒙者4号获得：<span class="red">{{
            this.enlightReward.no4.toFixed(2)
          }}</span>
          BNB</span
        >
        <br /><span
          >启蒙者5号获得：<span class="red">{{
            this.enlightReward.no5.toFixed(2)
          }}</span>
          BNB</span
        >
        <br /><span
          >启蒙者6号获得：<span class="red">{{
            this.enlightReward.no6.toFixed(2)
          }}</span>
          BNB</span
        >
        <br /><span
          >启蒙者7号获得：<span class="red">{{
            this.enlightReward.no7.toFixed(2)
          }}</span>
          BNB</span
        >
      </div>
      <div style="padding-left: 120px">
        <van-button @click="calcReward" type="primary">计算奖励</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { RadioGroup, Radio, Field } from 'vant'
import { isPC } from '@/assets/js/utils'

Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Field)

export default {
  data() {
    return {
      level: '',
      turnFee: 0.011543, //回合费
      bnbValue: 0,
      enlightenment: {
        no1: '',
        no2: '',
        no3: '',
        no4: '',
        no5: '',
        no6: '',
        no7: '',
        jackpot: '',
      },
      enlightReward: {
        no1: 0,
        no2: 0,
        no3: 0,
        no4: 0,
        no5: 0,
        no6: 0,
        no7: 0,
      },
    }
  },
  computed: {
    isPC() {
      return isPC()
    },
    result() {
      return `
      启蒙者1号获得：${this.enlightReward.no1.toFixed(2)} BNB,
      启蒙者2号获得：${this.enlightReward.no2.toFixed(2)} BNB,
      启蒙者3号获得：${this.enlightReward.no3.toFixed(2)} BNB,
      启蒙者4号获得：${this.enlightReward.no4.toFixed(2)} BNB,
      启蒙者5号获得：${this.enlightReward.no5.toFixed(2)} BNB,
      启蒙者6号获得：${this.enlightReward.no6.toFixed(2)} BNB,
      启蒙者7号获得：${this.enlightReward.no7.toFixed(2)} BNB,
      `
    },
  },
  methods: {
    calcReward() {
      const { no1, no2, no3, no4, no5, no6, no7, jackpot } = this.enlightenment
      let enlightList = [no1, no2, no3, no4, no5, no6, no7]
      // 总献祭分
      let totalScore = 0
      enlightList.forEach((num) => {
        if (Number(num)) {
          totalScore += Number(num)
        }
      })
      // 总献祭占比
      let totalPrecent = 0
      enlightList.forEach((num) => {
        if (Number(num)) {
          totalPrecent += totalScore / Number(num)
        }
      })
      // 启蒙者奖励
      this.enlightReward.no1 = no1
        ? (totalScore / Number(no1) / totalPrecent) * jackpot
        : 0
      this.enlightReward.no2 = no2
        ? (totalScore / Number(no2) / totalPrecent) * jackpot
        : 0
      this.enlightReward.no3 = no3
        ? (totalScore / Number(no3) / totalPrecent) * jackpot
        : 0
      this.enlightReward.no4 = no4
        ? (totalScore / Number(no4) / totalPrecent) * jackpot
        : 0
      this.enlightReward.no5 = no5
        ? (totalScore / Number(no5) / totalPrecent) * jackpot
        : 0
      this.enlightReward.no6 = no6
        ? (totalScore / Number(no6) / totalPrecent) * jackpot
        : 0
      this.enlightReward.no7 = no7
        ? (totalScore / Number(no7) / totalPrecent) * jackpot
        : 0
    },
    calc() {
      let { level } = this
      level = Number(level)
      if (!level) return
      let bnbValue = 0
      let turnFee = parseFloat(this.turnFee)
      let level1Value = this.getLevel1Value({ turnFee })
      let level2Value = level1Value * 2 + turnFee
      let level3Value = level2Value * 2 + turnFee
      let level4Value = level3Value * 2 + turnFee
      let level5Value = level4Value * 2 + turnFee
      let level6Value = level5Value * 2 + turnFee
      let level7Value = level6Value * 2 + turnFee
      let level8Value = level7Value * 2 + turnFee
      if (level === 1) {
        bnbValue = level1Value
      }
      if (level === 2) {
        bnbValue = level2Value
      }
      if (level === 3) {
        bnbValue = level3Value
      }
      if (level === 4) {
        bnbValue = level4Value
      }
      if (level === 5) {
        bnbValue = level5Value
      }
      if (level === 6) {
        bnbValue = level6Value
      }
      if (level === 7) {
        bnbValue = level7Value
      }
      if (level === 8) {
        bnbValue = level8Value
      }
      this.bnbValue = bnbValue
    },
    getLevel1Value({ turnFee }) {
      return turnFee / 3
    },
  },
  watch: {
    level(val) {
      if (val) {
        this.calc()
      }
    },
  },
}
</script>
<style lang="stylus" scoped>
.wrapper {
  // width 1260px
  margin 20px auto
  &.pc {
    width 1260px
    margin 50px auto
  }
  h1 {
    text-align center
  }
  .van-cell {
    background transparent
  }
  .btn-wrapper {
    padding-left 110px
    padding-top 20px
  }
  .result {
    line-height 1.8
    margin 10px 0
    padding-left 15px
    font-size 14px
  }
}
.red {
  color red
}
.van-radio--horizontal {
  margin-bottom 12px
}
</style>































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































// .nft-value{































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































//   span{































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































//     color red































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































//     font-size 20px































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































//   }































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































//   }































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































  































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































</style>